import { createUrlResolver } from '@seek/melways-sites';
import createUnistore from 'unistore';
import devtools from 'unistore/devtools';

import type { getInitialPageData } from 'src/setup/getInitialPageData';
import loadFeatures from 'src/setup/loadFeatures';
import { environments } from 'src/siteConfig';
import { isInBrowser } from 'src/utils/isInBrowser';

import type { Store } from '../types';

export const createStore = (
  initialPageData: ReturnType<typeof getInitialPageData>,
): Store => {
  const { environment, site, locale } = initialPageData;

  const state = {
    ...initialPageData,
    urlResolver: createUrlResolver({
      site,
      language: locale,
      staging: environment === 'staging',
    }),
    ...loadFeatures({ environment }),
  };
  const isClientSide = isInBrowser();

  return environment !== environments.production && isClientSide
    ? (devtools(createUnistore(state)) as unknown as Store)
    : (createUnistore(state) as unknown as Store);
};
